import React from 'react';
import { COLORS } from '../../theme';

export default function BackupsStub() {
  return (
    <div>
      <p style={{ color: COLORS.textMid, fontSize: 14, marginTop: 0 }}>Em breve — gestão de backups dos bancos de cada cliente.</p>
    </div>
  );
}
